export const user = {
  state: {
    userToken: '',
    roleId: '',
    userData: {},
    accessToken: '',
    currentRoute: '',
  },
  mutations: {
    'SET_USER_TOKEN' (state , token){
      state.userToken = token
    },
    'SET_USER_DATA' (state, userData) {
      state.userData = userData
    },
    'SET_ROLE_ID' (state, roleId) {
      state.roleId = roleId
    },
    'SET_ACCESS_TOKEN' (state, accessToken) {
      state.accessToken = accessToken
    },
    'SET_CURRENT_ROUTE' (state,currentRoute) {
      state.currentRoute = currentRoute
    }
  },
  actions: {
    setUserToken({commit},token){
      commit('SET_USER_TOKEN',token)
    },
    setUserData({commit}, userData) {
      commit('SET_USER_DATA', userData)
    },
    setRoleId({commit}, roleId) {
      commit('SET_ROLE_ID',roleId)
    },
    setAccessToken({commit}, accessToken) {
      commit('SET_ACCESS_TOKEN',accessToken)
    },
    setCurrentRoute({commit}, currentRoute) {
      commit('SET_CURRENT_ROUTE',currentRoute)
    }
  }
}
